export default {
  GET_REGIONS_LIST_LOADING: 'GET_REGIONS_LIST_LOADING',
  GET_REGIONS_LIST_SUCCESS: 'GET_REGIONS_LIST_SUCCESS',
  GET_REGIONS_LIST_FAILED: 'GET_REGIONS_LIST_FAILED',
  GET_REGIONS_LIST_REJECT: 'GET_REGIONS_LIST_REJECT',

  GET_REGIONS_NAMES_LOADING: 'GET_REGIONS_NAMES_LOADING',
  GET_REGIONS_NAMES_SUCCESS: 'GET_REGIONS_NAMES_SUCCESS',
  GET_REGIONS_NAMES_FAILED: 'GET_REGIONS_NAMES_FAILED',
  GET_REGIONS_NAMES_REJECT: 'GET_REGIONS_NAMES_REJECT',

  GET_REGION_BY_ID_LOADING: 'GET_REGION_BY_ID_LOADING',
  GET_REGION_BY_ID_SUCCESS: 'GET_REGION_BY_ID_SUCCESS',
  GET_REGION_BY_ID_FAILED: 'GET_REGION_BY_ID_FAILED',
  GET_REGION_BY_ID_REJECT: 'GET_REGION_BY_ID_REJECT',

  UPDATE_REGION_LOADING: 'UPDATE_REGION_LOADING',
  UPDATE_REGION_SUCCESS: 'UPDATE_REGION_SUCCESS',
  UPDATE_REGION_FAILED: 'UPDATE_REGION_FAILED',
  UPDATE_REGION_REJECT: 'UPDATE_REGION_REJECT',

  ADD_NEW_REGION_LOADING: 'ADD_NEW_REGION_LOADING',
  ADD_NEW_REGION_SUCCESS: 'ADD_NEW_REGION_SUCCESS',
  ADD_NEW_REGION_FAILED: 'ADD_NEW_REGION_FAILED',
  ADD_NEW_REGION_REJECT: 'ADD_NEW_REGION_REJECT',
};